/* eslint-disable @typescript-eslint/naming-convention */
import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConnectionsService {
  public _uploadProgress = new BehaviorSubject<number>(0);
  public _downloadProgress = new BehaviorSubject<number>(0);

  constructor() { }

  get api() {
    return environment.server + environment.api;
  }

  get auth() {
    return {
      login: 'auth/login',
      logout: 'auth/logout',
      logoutSession: 'auth/logout/session',
      validate: 'auth/validate',
      forgot: 'auth/forgot',
      register: 'auth/register',
      updateProfile: 'auth/updateProfile'
    };
  }

  get students() {
    return {
      class: 'students/class_name',
      list: 'students/list',
      detail: 'students/detail',
    };
  }

  get assessment() {
    return {
      list: 'assessment/list',
      detail: 'assessment/detail',
      create: 'assessment/create',
      update: 'assessment/update',
      delete: 'assessment/delete',
    };
  }

  get logs() {
    return {
      my: 'logs/my',
      all: 'logs/all',
      details: 'logs/details',
    };
  }

  get certificate() {
    return 'certificate';
  }

  get pbb() {
    return {
      role: 'pbb/roles',
      list: 'pbb/list',
      update: 'pbb/update',
      guide: 'pbb/guide',
    };
  }

  get training() {
    return {
      uploadCertificate: 'training/uploadCert',
      module: 'training',
      input: 'training/input',
      discuss: {
        list: 'training/discuss/list',
        create: 'training/discuss/create',
        read: 'training/discuss/read',
        reply: 'training/discuss/reply',
        update: 'training/discuss/update',
        destroy: 'training/discuss/destroy',
      },
      do: {
        list: 'training/do/list',
        submit: 'training/do/submit',
      },
      present: {
        list: 'training/present/list',
        create: 'training/present/create',
        read: 'training/present/read',
        reply: 'training/present/reply',
        update: 'training/present/update',
        destroy: 'training/present/destroy',
      },
      complete: 'training/complete',
      members: 'training/members',
      rate: 'training/rate'
    };
  }

  get data() {
    return {
      version: 'data/version',
      service: 'data/service',
      input: 'data/input',
      infoBlast: 'data/infoBlast',
      schools: 'data/schools',
    };
  }

  get uploadProgress() {
    return this._uploadProgress.asObservable();
  }

  get downloadProgress() {
    return this._downloadProgress.asObservable();
  }

  getProgressStatus(event) {
    let status: number;
    switch (event.type) {
      case HttpEventType.Sent: // 0
        return `Uploading Files`;
      case HttpEventType.UploadProgress: // 1
        status = Math.round(100 * event.loaded / event.total);
        this._uploadProgress.next(status);
        return `Files are ${status}% uploaded`;
      case HttpEventType.DownloadProgress: // 3
        status = Math.round(100 * event.loaded / event.total);
        this._downloadProgress.next(status); // NOTE: The Content-Length header must be set on the server to calculate this
        return `Files are ${status}% downloaded`;
      case HttpEventType.Response: // 4
        return event.body;
      default:
        return `Something went wrong`;
    }
  }

  resetProgress() {
    this._uploadProgress.next(0);
    this._downloadProgress.next(0);
  }

  options(token: string) {
    return {
      headers: {
        'Content-Type': 'application/json;',
        Authorization: 'Bearer ' + token,
      }
    };
  }

  formDataOptions(token: string) {
    return {
      headers: {
        enctype: 'multipart/form-data',
        Authorization: 'Bearer ' + token,
      },
    };
  }

  progressOptions(token: string) {
    return {
      headers: {
        enctype: 'multipart/form-data',
        Authorization: 'Bearer ' + token,
      },
      reportProgress: true,
    };
  }

}
